import { api } from '@/core';
import { ICompanyInfo } from '@/core/company/company.interface';

export const fetchCountry = () => {
  const endpoint = '/api/user/company-info';
  return api.get<ICompanyInfo>(endpoint);
};
